import { Form, Select, Slider, Input, Tag } from 'antd';
import { STATE_WORDS } from '../../utils/validation';
import { getMoodColor, getMoodLabel } from '../../utils/mood';

const { TextArea } = Input;

export const ScoreSlider = ({ label, value, onChange, required = false }) => {
  const color = getMoodColor(value);
  const moodLabel = getMoodLabel(value);

  return (
    <div className="score-field">
      <div className="score-field-label">
        <span>
          {label}
          {!required && (
            <span style={{ color: '#94a3b8', fontWeight: 400, marginLeft: 6 }}>(необязательно)</span>
          )}
        </span>
        <span className="score-badge" style={{ background: `${color}18`, color }}>
          <span className="score-badge-value">{value}</span>
          <span>{moodLabel}</span>
        </span>
      </div>
      <div className="score-slider-wrap">
        <Slider min={1} max={10} value={value} onChange={onChange} tooltip={{ open: false }} />
        <div className="score-marks">
          <span>1 — низко</span>
          <span>10 — отлично</span>
        </div>
      </div>
    </div>
  );
};

export const MultiSelectField = ({
  name,
  label,
  options,
  otherFieldName,
  form,
  rules,
  maxCount = 3,
  optional = false,
}) => {
  const selected = Form.useWatch(name, form) || [];
  const hasOther = selected.includes('other');
  const fieldRules = optional ? [] : rules;

  return (
    <>
      <Form.Item
        name={name}
        label={
          <>
            {label}
            {optional && (
              <span style={{ color: '#94a3b8', fontWeight: 400, marginLeft: 6 }}>(необязательно)</span>
            )}
          </>
        }
        rules={fieldRules}
      >
        <Select
          mode="multiple"
          maxCount={maxCount || undefined}
          allowClear
          placeholder={
            maxCount
              ? `До ${maxCount} вариантов`
              : 'Выберите один или несколько'
          }
          options={options}
          optionFilterProp="label"
        />
      </Form.Item>
      {hasOther && (
        <Form.Item
          name={otherFieldName}
          label="Уточните (другое)"
          rules={optional ? [] : [{ required: true, message: 'Укажите текст' }]}
        >
          <TextArea rows={2} placeholder="Ваш ответ" />
        </Form.Item>
      )}
    </>
  );
};

export const StateWordPicker = ({ value, onChange }) => (
  <div className="state-word-grid">
    {STATE_WORDS.map((word) => (
      <Tag.CheckableTag
        key={word}
        className="state-word-tag"
        checked={value === word}
        onChange={(checked) => onChange(checked ? word : undefined)}
      >
        {word}
      </Tag.CheckableTag>
    ))}
  </div>
);
